import { Link } from '@vgw/multibrand-fe-link'
import { Trans } from '@lingui/react/macro'
import { getBrandConfig } from '@/config/config'
import { useTracking } from '@vgw/multibrand-fe-tracking'

type FooterNavigationProps = {
  onCookiesConsentOpen: () => void
  onAMOEDialogOpen: () => void
  suppressAmoe: boolean
}

export const FooterNavigation = ({
  onCookiesConsentOpen,
  onAMOEDialogOpen,
  suppressAmoe,
}: FooterNavigationProps) => {
  const { pamLegalDocumentsUrl } = getBrandConfig()
  const { track } = useTracking()

  return (
    <nav className="grid grid-flow-col grid-cols-[auto_auto] grid-rows-3 gap-x-2 gap-y-1 md:flex md:flex-wrap md:justify-center md:gap-x-5 lg:flex-row">
      <Link
        size="xs"
        target="_blank"
        rel="noopener"
        href={`${pamLegalDocumentsUrl}/terms-and-conditions`}
        className="px-1.5 py-1 leading-4"
        weight="medium"
      >
        <Trans>Terms & Conditions</Trans>
      </Link>
      <Link
        size="xs"
        asChild
        className="px-1.5 py-1 text-left leading-4"
        weight="medium"
      >
        <button onClick={onCookiesConsentOpen}>
          <Trans>Your Privacy Choices</Trans>
        </button>
      </Link>
      <Link
        size="xs"
        target="_blank"
        rel="noopener"
        href={`${pamLegalDocumentsUrl}/privacy-policy`}
        className="px-1.5 py-1 leading-4"
        weight="medium"
      >
        <Trans>Privacy Policy</Trans>
      </Link>
      <Link
        size="xs"
        href="https://vgw--stage.sandbox.my.site.com/HelpLWR/"
        className="px-1.5 py-1 leading-4"
        weight="medium"
      >
        <Trans>Help Center</Trans>
      </Link>
      {!suppressAmoe && (
        <Link
          size="xs"
          asChild
          className="px-1.5 py-1 text-left leading-4"
          weight="medium"
        >
          <button
            onClick={() => {
              track('Postal Request Code Initiated', {
                eventData: {
                  'amoe request code point': 'footer',
                },
              })
              onAMOEDialogOpen()
            }}
          >
            <Trans>Postal Request Code</Trans>
          </button>
        </Link>
      )}

      <Link
        size="xs"
        target="_blank"
        rel="noopener"
        href={`${pamLegalDocumentsUrl}/responsible-social-gameplay-policy`}
        className="px-1.5 py-1 leading-4"
        weight="medium"
      >
        <Trans>Responsible Social Gameplay</Trans>
      </Link>
    </nav>
  )
}
